import { Grid } from "@mui/material";
import { ClientInsuranceNumberField } from "@shared";
import { FormikProps } from "formik";

import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<EditClientType>;
}

export function PersonalDataIdentitySection({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <Grid size={6}>
        <ClientInsuranceNumberField formik={formik} />
      </Grid>
      <Grid size={6}>
        <FormikDatePicker formik={formik} fieldName="birthday" label={t("clients.create.birthday")} />
      </Grid>
    </Grid>
  );
}
